import { render, staticRenderFns } from "./l2.vue?vue&type=template&id=ba92abf0&scoped=true&"
import script from "./l2.vue?vue&type=script&lang=js&"
export * from "./l2.vue?vue&type=script&lang=js&"
import style0 from "./l2.vue?vue&type=style&index=0&id=ba92abf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba92abf0",
  null
  
)

export default component.exports